import { render, staticRenderFns } from "./queueSettings.vue?vue&type=template&id=a23b4224&scoped=true&"
import script from "./queueSettings.vue?vue&type=script&lang=js&"
export * from "./queueSettings.vue?vue&type=script&lang=js&"
import style0 from "./queueSettings.vue?vue&type=style&index=0&id=a23b4224&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23b4224",
  null
  
)

export default component.exports